import { ErrorState } from '@bb/ui';
import { ApiError, type FunnelReport } from '../../../api/client.ts';

type Group = NonNullable<FunnelReport['groups']>[number];

/** A variant's name in a report, control as «Control», a variant only seen in data by its API id. */
export const groupLabel = (g: Pick<Group, 'name' | 'variantApiId' | 'isControl'>) => (g.isControl ? 'Control' : (g.name ?? g.variantApiId));

/**
 * Why a report did not come back: 422 `report_timeout` means the query was too heavy for its period (narrow it or
 * drop steps), 400 `invalid_property_filter` points at a filter; anything else is an error to retry.
 */
export function ReportError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  if (error instanceof ApiError && error.code === 'report_timeout') {
    return (
      <div role="alert" className="notice notice--warning">
        <strong>The report took too long.</strong> Narrow the period or remove steps, then run it again.
      </div>
    );
  }
  if (error instanceof ApiError && (error.code === 'invalid_property_filter' || error.code === 'validation_failed')) {
    return (
      <div role="alert" className="notice notice--warning">
        <strong>The report settings were refused:</strong> {error.message}
      </div>
    );
  }
  return <ErrorState title="The report could not be run" message={error instanceof ApiError ? error.message : 'Something went wrong.'} {...(error instanceof ApiError ? { code: error.code } : {})} onRetry={onRetry} />;
}
